import React, { useState } from 'react';
import { 
  Calendar, 
  Clock, 
  FileText, 
  Users,
  User,
  ChevronLeft,
  ChevronRight,
  Ban
} from 'lucide-react';
import BlockCalendarModal from './BlockCalendarModal';
import { toast } from 'react-toastify';
import useAxiosInstance from '../../lib/useAxiosInstance';
import { useMutation } from 'react-query';

const LeftSidebar = ({ onCalendarClick, onDNDCreated,onScheduleMeetingClick,teamStatus }) => {
  const axiosInstance=useAxiosInstance()
  const user = JSON.parse(localStorage.getItem("user"));
  const [currentDate, setCurrentDate] = useState(new Date());
  const [selectedDate, setSelectedDate] = useState(new Date().getDate());
  const [isBlockModalOpen, setIsBlockModalOpen] = useState(false);
  
  const currentMonth = currentDate.toLocaleString('default', { month: 'long' });
  const currentYear = currentDate.getFullYear();
  const today = new Date().getDate();

  const firstDay = new Date(currentDate.getFullYear(), currentDate.getMonth(), 1);
  const lastDay = new Date(currentDate.getFullYear(), currentDate.getMonth() + 1, 0);
  const daysInMonth = lastDay.getDate();
  const startingDayOfWeek = firstDay.getDay();

  const calendarDays = [];

  for (let i = 0; i < startingDayOfWeek; i++) {
    calendarDays.push(null);
  }

  for (let day = 1; day <= daysInMonth; day++) {
    calendarDays.push(day);
  }

  const handleDateClick = (day) => {
    setSelectedDate(day);
    const clickedDate = new Date(currentDate.getFullYear(), currentDate.getMonth(), day);
    const dateString = `${clickedDate.getFullYear()}-${String(clickedDate.getMonth() + 1).padStart(2, '0')}-${String(clickedDate.getDate()).padStart(2, '0')}`;
    onCalendarClick(dateString, 'timeGridDay');
};

  const handleMonthClick = () => {
  const dateOfCurrentMonth = new Date(currentDate.getFullYear(), currentDate.getMonth(), 1);
  const dateString = `${dateOfCurrentMonth.getFullYear()}-${String(dateOfCurrentMonth.getMonth() + 1).padStart(2, '0')}-01`;
  onCalendarClick(dateString, 'dayGridMonth');
};

  const handlePrevMonth = () => {
    const newDate = new Date(currentDate.getFullYear(), currentDate.getMonth() - 1, 1);
    setCurrentDate(newDate);
    setSelectedDate(null);
    const dateString = newDate.toISOString().split('T')[0];
    
  };

  const handleNextMonth = () => {
    const newDate = new Date(currentDate.getFullYear(), currentDate.getMonth() + 1, 1);
    setCurrentDate(newDate);
    setSelectedDate(null);
    const dateString = newDate.toISOString().split('T')[0]; 
  };

  const quickActions = [
    {
      id: '1',
      title: 'Schedule Meeting',
      icon: <Calendar className="w-5 h-5" />,
      color: '#004877',
      onClick: onScheduleMeetingClick
    },
    {
      id: '2',
      title: 'Block Calendar',
      icon: <Ban className="w-5 h-5" />,
      // color: 'from-red-500 to-red-600',
      // color: 'from-blue-500 to-blue-600',
      color: '#004877',
      onClick: () => setIsBlockModalOpen(true)
    },
    {
      id: '3',
      title: 'Team Management',
      icon: <Users className="w-5 h-5" />,
      // color: 'from-green-500 to-green-600',
      // color: 'from-blue-500 to-blue-600',
      color: '#004877',
      onClick: () => {}
    },
    {
      id: '4',
      title: 'Generate Report',
      icon: <FileText className="w-5 h-5" />,
      // color: 'from-orange-500 to-orange-600',
      // color: 'from-blue-500 to-blue-600',
      color: '#004877',
      onClick: () => {}
    }
  ];

  // const handleBlockCalendarSave = async (dndData) => {
  //   try {
  //     const result = await axiosInstance.post('api/eventScheduler/addDND',dndData)
  //     toast.success('Calendar blocked successfully!');
  //     setIsBlockModalOpen(false);
      
  //     // Notify parent component about new DND entry
  //     if (onDNDCreated) {
  //       onDNDCreated(result.data);
  //     }
  //   } catch (error) {
  //     toast.error(error.message || 'Failed to block calendar');
  //   }
  // };

  const { mutateAsync: addDND } = useMutation(
  async (dndData) => {
    const res = await axiosInstance.post('api/eventScheduler/addDND', dndData);
    return res.data;
  },
  {
    onSuccess: () => {
      toast.success('Calendar blocked successfully!');
      setIsBlockModalOpen(false);
      if (onDNDCreated) onDNDCreated(); // refetch from Dashboard
    },
    onError: (error) => {
      toast.error(error?.message || 'Failed to block calendar');
    }
  }
);

const handleBlockCalendarSave = async (dndData) => {
  await addDND(dndData);
};

  // const teamMembers = [
  //   { name: 'Sarah Johnson', role: 'Campaign Manager', status: 'online' },
  //   { name: 'Michael Brown', role: 'Communications Director', status: 'away' },
  //   { name: 'Jennifer Adams', role: 'Policy Analyst', status: 'online' },
  //   { name: 'David Wilson', role: 'Event Coordinator', status: 'offline' }
  // ];

  return (
    <div className="h-full space-y-6">
      {/* Mini Calendar */}
      <div className="shadow-[0_4px_16px_0_rgba(31,38,135,0.15)] transition-all duration-300 transform hover:shadow-[0_6px_24px_0_rgba(31,38,135,0.25)] text-black p-4 relative overflow-hidden rounded-3xl border border-white/30 backdrop-blur-3xl bg-gradient-to-br from-blue-50 via-yellow-100/20 to-emerald-50">
        <div className="flex items-center justify-between mb-4">
          <div className="flex items-center space-x-2">
            <button onClick={handlePrevMonth} className="p-1 hover:bg-white/20 rounded-md transition-colors">
              <ChevronLeft className="w-4 h-4 text-gray-600" />
            </button>
            <button onClick={handleMonthClick} className="text-lg font-semibold text-gray-800 hover:text-blue-600 transition-colors px-2">
              {currentMonth} {currentYear}
            </button>
            <button onClick={handleNextMonth} className="p-1 hover:bg-white/20 rounded-md transition-colors">
              <ChevronRight className="w-4 h-4 text-gray-600" />
            </button>
          </div>
        </div>

        <div className="grid grid-cols-7 gap-1 mb-2 ">
          {['S', 'M', 'T', 'W', 'T', 'F', 'S'].map((day, index) => (
            <div key={index} className="text-center text-xs font-medium text-gray-700 py-2">
              {day}
            </div>
          ))}
        </div>

        <div className="grid grid-cols-7 gap-1">
          {calendarDays?.map((day, index) => (
            <div
              key={index}
              onClick={() => day && handleDateClick(day)}
              className={`text-center text-sm py-2 rounded-md transition-colors ${
                day === selectedDate
                  ? 'bg-[var(--polstrat-primary)] text-white font-bold shadow-md' 
                  : day === today && selectedDate !== day
                  ? 'bg-blue-100 text-blue-600 font-medium'
                  : day
                  ? 'text-gray-700 hover:bg-blue-100/50 cursor-pointer'
                  : ''
              }`}
            >
              {day}
            </div>
          ))}
        </div>
      </div>

      {/* Quick Actions */}
     {user?.role!=='data_entry_operator' && <div className="shadow-[0_4px_16px_0_rgba(31,38,135,0.15)] transition-all duration-300 transform hover:shadow-[0_6px_24px_0_rgba(31,38,135,0.25)] text-black p-4 relative overflow-hidden rounded-3xl border border-white/30 backdrop-blur-3xl bg-gradient-to-br from-blue-50 via-yellow-100/20 to-emerald-50">
        <h3 className="text-lg font-semibold text-gray-800 mb-4">Quick Actions</h3>
        <div className="grid grid-cols-2 gap-3">
          {quickActions.map((action) => (
            <button
              key={action.id}
              onClick={action.onClick}
              className="flex flex-col items-center space-y-2 p-3 transition-all duration-300 transform hover:scale-[1.02] hover:shadow-[0_4px_16px_0_rgba(31,38,135,0.15)] cursor-pointer text-black p-3 relative overflow-hidden bg-gray-300/20 border border-gray-200 rounded-2xl"
            >
              <div 
              className={`p-2 rounded-lg  group-hover:scale-105 transition-transform text-white`}
              style={{ backgroundColor: '#004877'}}
              >
                {action.icon}
              </div>
              <span className="text-xs font-medium text-gray-600 text-center">{action.title}</span>
            </button>
          ))}
        </div>
      </div>}

      {/* Team Status */}
     {user?.role!=='data_entry_operator' && <div className="shadow-[0_4px_16px_0_rgba(31,38,135,0.15)] transition-all duration-300 transform hover:shadow-[0_6px_24px_0_rgba(31,38,135,0.25)] text-black p-4 relative overflow-hidden rounded-3xl border border-white/30 backdrop-blur-3xl bg-gradient-to-br from-blue-50 via-yellow-100/20 to-emerald-50">
        <div className="flex items-center justify-between mb-4">
          <h3 className="text-lg font-semibold text-gray-800">Team Status</h3>
          <Users className="w-5 h-5 text-gray-600" />
        </div>
        <div className="space-y-3">
          {teamStatus?.map((member, index) => (
            <div
              key={index}
              className="flex items-center space-x-3 p-3 transition-all duration-300 transform hover:scale-[1.02] hover:shadow-[0_4px_16px_0_rgba(31,38,135,0.15)] cursor-pointer text-black p-3 relative overflow-hidden bg-gray-300/20 border border-gray-200 rounded-2xl"
            >
              <div className="relative">
                <div className="w-8 h-8 bg-gradient-to-r from-blue-500 to-purple-500 rounded-full flex items-center justify-center">
                  <User className="w-4 h-4 text-white" />
                </div>
                <div
                  className={`absolute -bottom-1 -right-1 w-3 h-3 ${
                    member.status === 'online'
                      ? 'bg-green-400'
                      : member.status === 'away'
                      ? 'bg-yellow-400'
                      : 'bg-green-400'
                  } rounded-full border-2 border-white`}
                ></div>
              </div>
              <div className="flex-1 min-w-0">
                <p className="text-sm font-medium text-gray-800 truncate">{member.firstName} {member.lastName}</p>
                  <p className="text-xs text-gray-600">
                    {member.role === 'client'
                      ? 'Client'
                      : member.role === 'chief_of_staff'
                      ? 'Chief Of Staff'
                      : member.role === 'data_entry_operator'
                      ? 'DEO'
                      : member.role}
                  </p>
              </div>
            </div>
          ))}
        </div>
      </div>}

      {/* Block Calendar Modal */}
      <BlockCalendarModal
        isOpen={isBlockModalOpen}
        onClose={() => setIsBlockModalOpen(false)}
        onSave={handleBlockCalendarSave}
      />
    </div>
  );
};

export default LeftSidebar;
